import { FormControl, FormLabel, HStack, Input, Text } from "@chakra-ui/react";
import React from "react";

const DateRange = ({ formik, field1, field2, isRequired = false, label }) => {
  return (
    <FormControl isRequired={isRequired}>
      <HStack>
        <FormLabel whiteSpace="nowrap" mb={0}>
          {label ?? "租期："}
        </FormLabel>
        <Input
          type="date"
          variant="filled"
          {...formik.getFieldProps(field1)}
          w="fit-content"
        />
        <Text>-</Text>
        <Input
          type="date"
          variant="filled"
          {...formik.getFieldProps(field2)}
          w="fit-content"
        />
      </HStack>
    </FormControl>
  );
};

export default DateRange;
